export default "__VITE_ASSET__DUMUWvuI__"